import React, { Component } from 'react';
import axios from 'axios'
import * as moment from 'moment';
import { serverIp, getOrderKey, pythonApiIp, whatsapp_api_glassfish } from '../../../../config/constants.js'
import { Button, Header, Icon } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Status from '../../../../config/OrderStatusConstants.js'
import * as UiConsts from '../../../../config/UiConstants.js'

class WhatsappSendImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        }
    }


    componentDidMount() {
        // console.log("++++++++++:WhatsappSendImage");
        // console.log("this.props.order.key:" + this.props.order.key);
    }

    sendDesign = (sentType) => {

        this.setState({ loading: true })

        axios.post(whatsapp_api_glassfish + 'sendImageFullProcess', {

            apiKey: 'asdfasdfsf',
            phone: this.props.order.phone,
            itemType: this.props.order.itemType,
            imageUrl: this.props.order.designImageUrl,
            order_num: this.props.order.order_num,
            fborderkey: getOrderKey(this.props.order),
            resend_design: true
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);
                if (response.data.result) {
                    alert(response.data.message)
                }
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log(error);
            });

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');
        var tt = d.getTime();

        // let orderUpdates = {
        //     whatapp_image_sent: true,
        //     whatapp_image_sent_on: now,
        //     whatapp_image_sent_on_secs: tt,
        //     whatapp_image_sent_by: this.props.user.email,
        // }

        // //upATE MAIN ORDER
        // FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);
    }


    render() {

        // const whatsAppImageHeader = this.props.order.whatapp_designsent
        //     ? <Header as='h4'>
        //         Design Sent On :{this.props.order.whatapp_image_sent_on}
        //         <Header.Subheader>
        //             Message Status: {this.props.order.whatapp_designsent_status}
        //         </Header.Subheader>
        //     </Header>
        //     : ''

        const whatsAppImageHeader = <Header as='h3'>
            Design Sent:{this.props.order.whatapp_designsent}
            <Header.Subheader>
                Design Sent Status: {this.props.order.whatapp_designsent_status}
            </Header.Subheader>
            <Header.Subheader>
                Design Sent On: {this.props.order.whatapp_image_sent_on}
            </Header.Subheader>
        </Header>


        const sendDesignButton = this.props.order.designImageUrl 
        && this.props.order.status == Status.new_design_added
        && !this.props.searchNow
            ? <Button icon labelPosition='left' onClick={this.sendDesign} color='green' size='medium'>
                <Icon name='whatsapp' />
                 RESEND DESIGN</Button>
            : ''


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <br />
                {/* {wholeUI} */}
                {whatsAppImageHeader}
                {sendDesignButton}
            </div>
        )
    }
}

export default WhatsappSendImage;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappSendImage.js